module.exports = __webpack_public_path__ + "img/ysdIcon.7b1a5ca5.svg";